import { Box } from "@mui/material";
import React, { useEffect } from "react";
import HeaderController from "../../diaryList/organizms/HeaderController";
import { useRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import { User } from "../../../types";
import { setUserToLocalStorage } from "../../../utils/functions/localStorageManager";
import classes from "./DiaryList.module.scss";
import DisplayArea from "../../diaryList/displayArea/DisplayArea";
const DiaryList = () => {
  const [user, setUser] = useRecoilState(userState);
  useEffect(() => {
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          latestUrl: "/",
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  }, []);
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <HeaderController />
      <DisplayArea />
    </Box>
  );
};

export default DiaryList;
